import { render } from "./ContactsView.vue?vue&type=template&id=5ca23cc4&scoped=true&ts=true"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"

import "./ContactsView.vue?vue&type=style&index=0&id=5ca23cc4&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca23cc4"]])

export default __exports__